import fetchApi from "../fetchApi";
import useAuth from "../../hooks/useAuth";
import { useMutation } from "@tanstack/react-query";

const useMutationAcceptLoanApplication = (options?: any) => {
  const { token } = useAuth();
  return useMutation({
    mutationKey: ["AcceptLoanApplication"],
    mutationFn: ({ loanId }: { loanId: string }) =>
      fetchApi(`acceptLoanApplication?id=${loanId}`, token).get(),
  });
};

export default useMutationAcceptLoanApplication;
